export const toLogMessage = (message: string) =>
  `[voomly-embed-player] ${message}`;
